export const YduqsApiMap = [
  {
    api: 'http://localhost:5001',
    envs: ['local', 'ci'],
    apm: 'https://0a45548b388140afad378bed5b3c4c21.apm.eastus.azure.elastic-cloud.com:443',
    brand: 'yduqs',
    tempoDedupping: 1800000,
  },
];
